<template>
    <div class="bg-gray w-full pt-16 ">
        <div class="max-w-(--breakpoint-2xl) container mx-auto px-4 lg:px-4 pt-4 relative py-16">
            <div class="text-center w-full">
                <strong class="text-2xl">Direct antwoord op je vraag?</strong>
                <div class="text-xl text-gray-600">Wij staan voor je klaar.</div>
            </div>
            <div class="md:flex justify-center items-center my-10 gap-x-6 ">

                <div class="mb-4 md:mb-0" v-for="channel in channels" :key="channel.title">
                    <a :href="channel.url ?? 'javascript:void(0)'" @click="channel.openChat" :target="channel.icon == 'envelope' ? '_blank' : ''" class="cursor-pointer rounded-xl py-4 px-6 inline-flex items-center justify-center text-base font-medium hover:shadow transition border border-dgreen/30 hover:border-dgreen/80 bg-white w-full md:w-auto">
                        <div class="flex flex-wrap items-center py-3 md:w-64 w-full">
                            <div class="w-1/4 text-center">
                                <fa :icon="[channel.iconType, channel.icon]" class="inline-block w-8 h-8 text-dgreen" />
                            </div>

                            <div class="w-3/4 pl-4">
                                <strong class="block text-xl font-semibold">{{ channel.title }}</strong>
                                <span class=" text-sm font-normal">{{ channel.response }}<span class="text-xs -mt-1 inline-block">*</span></span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="md:text-center w-full">
                <div class="text-gray-700 text-sm">*Geldt op werkdagen van 09:00 tot 17:00.</div>
            </div>
            <div class="absolute right-0 bottom-0"> 
                <vue-picture
                    class="hidden md:block"
                    :image="{
                        src: asset(
                            'img/kevin.webp'
                        ),
                        origin_src: asset(
                            'img/kevin.png'
                        ),
                    }"
                    name="Kevin klantenservice"
                    :notlazy="true"
                    :width="286"
                    :height="432"
                />
                <vue-picture
                    class="block md:hidden"
                    :image="{
                        src: asset(
                            'img/kevin.webp'
                        ),
                        origin_src: asset(
                            'img/kevin.png'
                        ),
                    }"
                    name="Kevin klantenservice"
                    :notlazy="true"
                    :width="120"
                    :height="180"
                />
            </div>
        </div>

    </div>
</template>

<script setup>
const props = defineProps({
    post: Object,
});

const channels = [
    {
        title: 'Live chat',
        response: 'Direct contact',
        openChat: () => {
            window.mitt.emit('open-intercom')
        },
        icon: 'comments',
        iconType: 'fas',
    },
    {
        title: 'info@doorax.nl',
        response: 'Reactie binnen 12uur',
        url: 'mailto:info@doorax.nl',
        icon: 'envelope',
        iconType: 'fas',

    },
    {
        title: '026-2340303',
        response: 'Direct contact',
        url: "tel:+31262340303",
        icon: 'phone',
        iconType: 'fas',
    },
];
</script>
